import React, { useEffect, useState } from "react";
import { usePlatformAuth } from "context/PlatformAuthContext";
import { platformApiService } from "services/platformApi";
import { useNavigate } from "react-router-dom";

const PlatformInvoices: React.FC = () => {
 const { isAuthenticated } = usePlatformAuth();
 const navigate = useNavigate();
 const [invoices, setInvoices] = useState<any[]>([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
  if (!isAuthenticated) {
   navigate("/platform/login", { replace: true });
   return;
  }

  fetchInvoices();
 }, [isAuthenticated, navigate]);

 const fetchInvoices = async () => {
  try {
   const response = await platformApiService.getInvoices();
   setInvoices(response.data.invoices || []);
  } catch (error) {
   console.error("Error fetching invoices:", error);
  } finally {
   setLoading(false);
  }
 };

 if (loading) {
  return <div className="p-8">Loading invoices...</div>;
 }

 return (
  <div className="p-8">
   <h1 className="text-3xl font-bold mb-6">Invoices</h1>
   <div className="bg-white shadow overflow-hidden">
    <table className="min-w-full divide-y divide-gray-200">
     <thead className="bg-gray-50">
      <tr>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Invoice #
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Store
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Amount
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Status
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Due Date
       </th>
      </tr>
     </thead>
     <tbody className="bg-white divide-y divide-gray-200">
      {invoices.map((invoice) => (
       <tr key={invoice._id}>
        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
         {invoice.invoiceNumber}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
         {(invoice.storeId as any)?.name || "N/A"}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
         {invoice.currency} {invoice.amount.toFixed(2)}
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
         <span
          className={`px-2 inline-flex text-xs leading-5 font-semibold ${
           invoice.status === "paid"
            ? "bg-green-100 text-green-800"
            : invoice.status === "open"
            ? "bg-yellow-100 text-yellow-800"
            : "bg-red-100 text-red-800"
          }`}
         >
          {invoice.status}
         </span>
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
         {new Date(invoice.dueDate).toLocaleDateString()}
        </td>
       </tr>
      ))}
     </tbody>
    </table>
   </div>
  </div>
 );
};

export default PlatformInvoices;





